// extracted by mini-css-extract-plugin
module.exports = {"titleInGame":"titleInGame_titleInGame__3_ef3","flashText":"titleInGame_flashText__1Qfer"};